<template>
  <div class="verify-email">
    <NhstValidateCodeAndChangePassword
      :description="description"
      @loggedInSuccess="onEmailVerified" />
  </div>
</template>

<script>

import { NhstValidateCodeAndChangePassword } from '@components/reset-password';
import { addTrackingEvent } from '@root/src/helpers/Tracking';
import { normalizeToLowerSnakeCase } from '@root/src/helpers/trackingLabels';
import { EXTERNAL_CONFIGS } from '@root/src/helpers/ExternalConfigs';

export default {
  name: 'nhst-verify-username',
  components: { NhstValidateCodeAndChangePassword },
  computed: {
    description() {
      return this.$t(
        'reset.password.validate.code.activate.subscription.description',
        { email: this.username }
      );
    }
  },
  mounted() {
    if (!this.isDN) {
      this.$authWebapp.pushAnalyticsTrackingEventForGlobalOrderflow();
    }
    this.trackStep('Validate Code And Change Password');
  },
  methods: {
    trackStep(verbalName) {
      const identifierValue = normalizeToLowerSnakeCase(verbalName);
      if (!identifierValue) return;
      let paywallVariation = this.$route.query.paywall_variation_type || '';
      let registrationService = this.$authWebapp.getSource() || '';
      let identifierType = 'registration_step';
      let subProducerContract = { name: 'registration', version: '1' };
      if (!this.isDN) {
        paywallVariation =
          sessionStorage.getItem(
            EXTERNAL_CONFIGS.STORAGE_KEYS.PAYWALL_VARIATION
          ) || '';
        registrationService = paywallVariation ? 'PAYWALL' : 'ORDERFLOW';
        identifierType = 'order_flow_step';
        subProducerContract = { name: 'order_flow', version: '1' };
      }
      addTrackingEvent({
        event: 'system_action',
        sub_producer_contract: subProducerContract,
        attributes: {
          action: 'show',
          identifier_type: identifierType,
          identifier_value: identifierValue,
          registration_service: registrationService,
          paywall_variation: paywallVariation,
          flow_source_url: this.$authWebapp.getTarget('') || '',
        },
      });
    },
    onEmailVerified() {
      this.trackStep('Email Verified');
    }
  }
};
</script>
